var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<ninja-grid no-data-text=\"No emails yet...\" grid-title=\"Company Emails\" doc-svc=\"vm.docSvc\" list=\"vm.docSvc.doc.emails\" create-method=\"addEmail\" update-method=\"\" delete-method=\"deleteEmail\" add-toggle=\"vm.sideTab.emails\" fields=\"{emailType: {input: 'text', header: 'Type', order: 10, width: 20, type: 'string'}, \n                 primary: {input: 'textarea', header: 'Primary', order: 20, width: 10, type: 'string'}, \n                 email: {input: 'text', header: 'Email Address', order: 30, width: 50, type: 'string'}}\"></ninja-grid>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/administration/settings/tabs/emails.jade
// module id = 171
// module chunks = 0